const alertMessage = 'Sorry, we haven\'t found any recipes for these filters.';
const maxSize = 12;

export async function fetchFoodsFiltered({ filter, value }) {
  const getData = {
    ingredient: `https://www.themealdb.com/api/json/v1/1/filter.php?i=${value}`,
    name: `https://www.themealdb.com/api/json/v1/1/search.php?s=${value}`,
    fLetter: `https://www.themealdb.com/api/json/v1/1/search.php?f=${value}`,
    nationality: `https://www.themealdb.com/api/json/v1/1/filter.php?a=${value}`,
  };

  try {
    const request = await fetch(getData[filter]);
    const { meals } = await request.json();
    if (meals === null) {
      global.alert(alertMessage);
      return [];
    }
    return meals.slice(0, maxSize);
  } catch (err) {
    global.alert(alertMessage);
    return [];
  }
}

export async function fetchDrinksFiltered({ filter, value }) {
  const getData = {
    ingredient: `https://www.thecocktaildb.com/api/json/v1/1/filter.php?i=${value}`,
    name: `https://www.thecocktaildb.com/api/json/v1/1/search.php?s=${value}`,
    fLetter: `https://www.thecocktaildb.com/api/json/v1/1/search.php?f=${value}`,
  };

  try {
    const request = await fetch(getData[filter]);
    const { drinks } = await request.json();
    if (drinks === null) {
      global.alert(alertMessage);
      return [];
    }
    return drinks.slice(0, maxSize);
  } catch (err) {
    global.alert(alertMessage);
    return [];
  }
}
